/** Copyright (c) 2018 T. Rowe Price. All rights reserved. */

import './RMDTable.scss';

import React from 'react';
import {currency, lastBusinessDay} from "../../../../utils/dashboard-utils";

const TableHeader = (props) => {
    if (props) {
        if (props.showYTDColumns) {
            return (
                <thead>
                    <tr className="columns ">
                        <th className="name" />
                        <th className="account">Account</th>
                        <th className="account-balance"><div>{lastBusinessDay(props.currentRmdYear)}</div> Account Balance</th>
                        <th className="year-rmd">{props.currentRmdYear} RMD</th>

                        <th className="distributions-ytd">YTD Distributions</th>
                        <th className="remaining-year">Remaining for the year</th>
                        <th className="tax-ytd">YTD Tax Withholding</th>
                    </tr>
                    <tr className="totals">
                        <td className="name">Total Balance</td>
                        <td className="account"></td>
                        <td className="account-balance">{props.totalBalance}</td>
                        <td className="year-rmd">{props.totalRMD}</td>

                        <td className="distributions-ytd">{currency(props.rmdSummary.actualDistributionTotal)}</td>
                        <td className="remaining-year">{currency(props.rmdSummary.totalRemainingYear)}</td>
                        <td className="tax-ytd">{currency(props.rmdSummary.totalTaxWithHoldings)}</td>
                    </tr>
                </thead>
            );
        };
        return (
            <thead>
                <tr className="columns ">
                    <th className="name" />
                    <th className="account">Account</th>
                    <th className="account-balance"><div>{lastBusinessDay(props.currentRmdYear)}</div> Account Balance</th>
                    <th className="year-rmd">{props.currentRmdYear} RMD</th>
                </tr>
                <tr className="totals">
                    <td className="name">Total Balance</td>
                    <td className="account"></td>
                    <td className="account-balance">{props.totalBalance}</td>
                    <td className="year-rmd">{props.totalRMD}</td>
                </tr>
            </thead>
        );
    }
};

export default TableHeader;